import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_BASE_URL } from './tokens';
import { Observable } from 'rxjs';
import { Gateway } from 'src/utils/models/gateway.model';

@Injectable()
export class GatewayApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  private gatewayUrl: string;

  constructor() {
    const baseUrl = this.baseUrl;
    this.gatewayUrl = baseUrl + '/gateways';
  }

  public get$(serial: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.gatewayUrl}?serial=${serial}`);
  }

  public create$(gateway: Partial<Gateway>): Observable<Gateway> {
    return this.http.post<Gateway>(this.gatewayUrl, gateway);
  }

  public getGatewayInfo$(serial: string): Observable<Gateway> {
    return this.http.get<Gateway>(`${this.gatewayUrl}/${serial}`);
  }
}
